<script lang="ts" setup>
  import { useSlots } from 'vue'

  const props = withDefaults(
    defineProps<{
      caption?: string
      link?: string
      color?: string
      as?: string
      disabled?: boolean
      isToggle?: boolean
      captionClasses?: string
      btnClasses?: string

      ariaLabel?: string
    }>(),
    {
      caption: '',
      link: '',
      color: 'black',
      left: true,
      as: undefined,
      captionClasses: '',
      btnClasses: '',

      ariaLabel: '',
    }
  )

  const slots = useSlots()
</script>

<template>
  <div
    class="button flex items-center cursor-pointer rounded text-sm"
    :class="[props.color]"
  >
    <router-link
      v-if="props.link"
      :to="props.link"
      :type="props.as"
      :disabled="props.disabled"
      class="flex w-auto h-auto items-center justify-center text-center"
      :aria-label="props.ariaLabel"
    >
      <!-- Icon -->
      <slot name="prepend-icon" />

      <!-- Caption -->
      <span
        v-if="props.caption"
        :class="[slots['prepend-icon'] ? '' : 'mr-2', captionClasses]"
      >
        {{ props.caption }}
      </span>

      <!-- Icon -->
      <slot />
    </router-link>

    <button
      v-else
      class="flex w-auto h-auto items-center justify-center text-center"
      :class="props.btnClasses"
      :disabled="props.disabled"
      :aria-label="props.ariaLabel"
    >
      <!-- Icon -->
      <slot name="prepend-icon" />

      <!-- Caption -->
      <span
        v-if="props.caption"
        :class="[slots['prepend-icon'] ? '' : 'mr-2', captionClasses]"
      >
        {{ props.caption }}
      </span>

      <!-- Icon -->
      <slot />
    </button>
  </div>
</template>

<style scoped>
  .button {
    transition: all 0.1s ease-out;
  }
  /* Colors */
  .button.black {
    color: black;
  }
  .button.white {
    color: white;
  }
</style>
